import React from "react";
import { Props } from "./types";

function MaterialResourceIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 44.238 50.918">
      <g
        id="Groupe_1165"
        data-name="Groupe 1165"
        transform="translate(-16.897 -8)"
      >
        <g
          id="Groupe_2007"
          data-name="Groupe 2007"
          transform="translate(-1842.491 -740.993)"
        >
          <path
            id="Tracé_3001"
            data-name="Tracé 3001"
            d="M1932.554,748.993c2.494,1.682,5.166,3.063,7.757,4.581,4.651,2.724,9.321,5.414,13.983,8.118.053.522-.394.649-.711.831-6.73,3.861-13.424,7.787-20.169,11.622-.4.228-.894.794-1.291-.051a5.678,5.678,0,0,1-.091-1.388q0-10.992,0-21.984a2.8,2.8,0,0,1,.322-1.728Z"
            transform="translate(-50.854 0)"
            fill="#232f34"
          />
          <path
            id="Tracé_3002"
            data-name="Tracé 3002"
            d="M1881.935,748.993l-.006,25.485-.139.047a33.636,33.636,0,0,1-4.435-2.422c-5.367-3.086-10.739-6.164-16.079-9.3-.47-.276-1.165-.357-1.267-1.089q6.474-3.768,12.948-7.536c2.691-1.563,5.393-3.108,8.083-4.672.247-.143.564-.212.7-.517Z"
            transform="translate(-0.434 0)"
            fill="#333"
          />
          <path
            id="Tracé_3003"
            data-name="Tracé 3003"
            d="M1932.345,804.119l13.417-7.736q3.655-2.108,7.314-4.211a4.228,4.228,0,0,0,1.215-.838c.293.271.154.625.154.938q.013,11.887.013,23.772a1.159,1.159,0,0,1-.6,1.212q-10.495,6.018-20.962,12.087a3.739,3.739,0,0,1-.538.21,2.066,2.066,0,0,1-.331-1.422q-.007-11.3,0-22.6a1.831,1.831,0,0,1,.313-1.415Z"
            transform="translate(-50.851 -29.641)"
            fill="#303d44"
          />
          <path
            id="Tracé_3004"
            data-name="Tracé 3004"
            d="M1881.495,804.18q.007,12.717.014,25.435-5.86-3.352-11.719-6.706c-3.216-1.848-6.418-3.72-9.642-5.555a1.231,1.231,0,0,1-.751-1.223c.024-7.958.014-15.917.022-23.875,0-.278-.134-.6.155-.833,2.585,1.528,5.16,3.072,7.757,4.58Q1874.4,800.108,1881.495,804.18Z"
            transform="translate(0 -29.704)"
            fill="#656765"
          />
        </g>
      </g>
    </svg>
  );
}

export { MaterialResourceIcon };
